import { useQuery } from '@tanstack/react-query'

import { isAccessDenied, isTransientQueryError } from './useAttributionObservability'

import type { AttributionDimension, AttributionFilters } from '@/api/attributionObservability'
import { getSummaryChipCohorts, getSummaryChipOverview, getSummaryChipTrend } from '@/api/summaryChipMetrics'

const defaults = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
  retry: (attempt: number, error: unknown) => attempt < 1 && !isAccessDenied(error) && isTransientQueryError(error),
} as const

export const useSummaryChipOverview = (filters: AttributionFilters, enabled: boolean) =>
  useQuery({
    ...defaults,
    enabled,
    queryKey: ['attribution-observability', 'summary-chips', 'overview', filters],
    queryFn: ({ signal }) => getSummaryChipOverview(filters, signal),
  })
export const useSummaryChipCohorts = (filters: AttributionFilters, dimension: AttributionDimension) =>
  useQuery({
    ...defaults,
    staleTime: 60_000,

    queryKey: ['attribution-observability', 'summary-chips', 'cohorts', filters, dimension],
    queryFn: ({ signal }) => getSummaryChipCohorts(filters, dimension, signal),
  })
export const useSummaryChipTrend = (filters: AttributionFilters, axes: AttributionDimension[], enabled: boolean) =>
  useQuery({
    ...defaults,
    enabled,
    queryKey: ['attribution-observability', 'summary-chips', 'trend', filters, axes],
    queryFn: ({ signal }) => getSummaryChipTrend(filters, axes, signal),
  })
